import React from 'react'
import { Layout as RaLayout } from 'react-admin'
import { makeStyles } from '@material-ui/core/styles'
import Box from '@material-ui/core/Box'
import AppBar from './AppBar'
import Menu from './Menu'
import Footer from './Footer'
import { useBrand } from '../hooks/useBrand'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  content: {
    flex: 1,
    display: 'flex',
  },
}))

const Layout = (props) => {
  const classes = useStyles()
  const brand = useBrand()

  return (
    <div className={classes.root}>
      <RaLayout
        {...props}
        appBar={AppBar}
        theme={brand.theme}
        menu={Menu}
        className={classes.content}
      />
      <Footer />
    </div>
  )
}

export default Layout
